import { render, staticRenderFns } from "./InfoWidget.vue?vue&type=template&id=a647c596&scoped=true&"
import script from "./InfoWidget.vue?vue&type=script&lang=js&"
export * from "./InfoWidget.vue?vue&type=script&lang=js&"
import style0 from "./InfoWidget.vue?vue&type=style&index=0&id=a647c596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a647c596",
  null
  
)

export default component.exports